export const SIDE_BUY = 1;
export const SIDE_SELL = 0;
export const ORDER_BOOK_RENDER_SIZE = 15;
export const MAX_DIGITS = 8;
export const MIN_DIGITS = 2;
export const MAIN_UP_COLOR = '#46b98d';
export const MAIN_DOWN_COLOR = '#de4014';
export const SUB_UP_COLOR = '#46b99f';
export const SUB_DOWN_COLOR = '#de4014';
